import { Directive, HostListener, Inject } from '@angular/core';

import { AccordionLinkDirective } from './accordionlink.directive';

@Directive({
  selector: '[appAccordionToggle]',
  standalone: true
})
export class AccordionAnchorDirective {
  private navlink: AccordionLinkDirective;

  public constructor(@Inject(AccordionLinkDirective) navlink: AccordionLinkDirective) {
    this.navlink = navlink;
  }

  @HostListener('click')
  public onClick(): void {
    this.navlink.toggle();
  }
}
